import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { components } from 'react-select';
import classNames from 'classnames/bind';
import { arrayOf, func, node, oneOfType } from 'prop-types';
import { getMethodsForTestId } from "../../utils/getMethodsForTestId";
import styles from '../Select.css';
import { selectPropsPropTypes } from '../shapes';
var cx = classNames.bind(styles);
export var Input = function Input(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var innerRef = props.innerRef,
      _props$selectProps = props.selectProps,
      isMulti = _props$selectProps.isMulti,
      isMobile = _props$selectProps.isMobile,
      value = _props$selectProps.value,
      autoComplete = _props$selectProps.autoComplete,
      inputRef = _props$selectProps.inputRef,
      classes = _props$selectProps.classes,
      namespace = _props$selectProps.namespace;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'input'),
      getTestId = _getMethodsForTestId.getTestId;

  var handleRef = function handleRef(ref) {
    inputRef.current = ref;
    innerRef(ref);
  };

  return isMobile ? null : /*#__PURE__*/React.createElement(components.Input, _extends({}, props, getTestId(), {
    innerRef: handleRef,
    autoComplete: autoComplete || 'off',
    className: cx('Input', {
      Input_multiHasValue: isMulti && !!value,
      Input_hasValue: value,
      Input_autoComplete: autoComplete
    }, classes.input)
  }), children);
};
Input.propTypes = process.env.NODE_ENV !== "production" ? {
  children: oneOfType([arrayOf(node), node]),
  innerRef: func,
  selectProps: selectPropsPropTypes
} : {};